import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import axios from 'axios';
import VueAxios from 'vue-axios';

const formularios = {
	state: {
		logged: !!window.localStorage.getItem('_token'),
	},
	getters: {
		getLogged: state => state.logged,
	},
	actions: {
		login : ({commit}, data) => {
			return new Promise((resolve, reject) => {
				axios.post('api/external/login',data).then( result => {

                    if(result.data.status){
						window.localStorage.setItem('_token', result.data.token);
						commit('setLogged');
						resolve(true);
                    }else{
						resolve(false);
						commit('setError',response.data.error);
					}
					
				}).catch(error => {
					reject(false);
				});  
			});	
		},
		requestLogout : ({commit})  => {
			return new Promise((resolve, reject) => {
				axios.post('api/external/logout').then( result => {
					if(result.data.status){
						commit('setLogout');
						resolve(true);
					}
				}).catch(error => {
					reject(false);
				});  

			});
		},
		requestRegister : ({commit}, data)  => {
			return new Promise((resolve, reject) => {
				axios.post('api/external/register',data).then( result => {
					if(result.data.status){
						resolve(true);
					}else{
						resolve(false);
					}
				}).catch(error => {
					reject(false);
				});  

			});
        },
        requestuser : ({commit})  => {


			return new Promise((resolve, reject) => {
				axios.get('api/external/user').then( result => {
					if(!!result.data.id){
						resolve(result.data);
					}else{
						resolve(false);
					}
				}).catch(error => {
					reject(false);
				});  

			});
		},
		requestcards : ({commit})  => {

			return new Promise((resolve, reject) => {
				axios.get('api/cashier/card/list').then( result => {
					if(!!result.data.cards){
						resolve(result.data.cards);
					}
				}).catch(error => {
					reject(false);
				});  

			});
		},
		makeIntentSave : ({commit,dispatch}, data) => {
			return new Promise((resolve, reject) => {
                axios.get('api/cashier/card/intent').then(response => {
                    resolve(response.data.intent.client_secret);
                });
			});	
		},
		saveCard : ({commit,dispatch}, setupIntent) => {
			return new Promise((resolve, reject) => {
                axios.post('api/cashier/card/save', {setupIntent : setupIntent}).then(response => {
                    resolve(response.status);
                });
			});	
		},
		requesteraseCard : ({commit,dispatch}, id) => {
			return new Promise((resolve, reject) => {
                axios.post('api/cashier/card/delete', {cardId : id}).then(response => {
                    resolve(response.status);
                });
			});	
		},
		rememberPassword : ({commit},data)  => {
			return new Promise((resolve, reject) => {
				axios.post('api/external/send_password',data).then( result => {
					if(result.data.status){
						resolve(true);
					}
				}).catch(error => {
					reject(false);
				});  

			});
        },
        resetpassword : ({commit},data)  => {
			return new Promise((resolve, reject) => {
				axios.post('api/external/reset_password',data).then( result => {
					if(result.data.status){
						resolve(true)
					}
				}).catch(error => {
					reject(false);
				});  

			});
        },
        checkLogged:({commit}) => {
            return new Promise((resolve, reject) => {
                
                const token = window.localStorage.getItem('_token');

                if(!!token){
                    resolve(true);
                    commit('setLogged');
                }else{
                    resolve(false);
                }

			});
        }
	},
	mutations: {

        setLogged(state) {

			if (!!window.localStorage.getItem('_token')) {

				const token = window.localStorage.getItem("_token");
		
				axios.defaults.headers.common['authorization'] = `Bearer ${token}`;

				state.logged = true;
				state.token = token;
			
			}

		},
		setLogout(state){
			state.logged = false;
			window.localStorage.clear();
			window.sessionStorage.clear();
			window.localStorage.setItem('cookie:accepted', true);
		}
		
	}
}

export default formularios;



// WEBPACK FOOTER //
// ./src/store/authentication.js